import cx from 'classnames';

import { makeStyles } from '@mui/styles';

import Skeleton from '@classify/react-core-components/Skeleton';

const useStyles = makeStyles(
  /* istanbul ignore next */ ({ spacing, palette, breakpoints, radius }) => ({
    root: {
      width: '100%',
      display: 'grid',
      gap: spacing(2),
      paddingTop: spacing(2),
      borderRadius: radius.productCard,
      backgroundColor: palette.background.primary,
      gridTemplateColumns: '1fr 1.5fr',
      gridTemplateAreas: `
        "image content"
        "footer footer"
      `,
      [breakpoints.up('sm')]: {
        gridTemplateColumns: '1fr 1fr 1fr 1fr',
        gridTemplateAreas: `
        "image content content content"
        "footer footer footer footer"
      `,
      },
    },
    image: {
      gridArea: 'image',
      marginLeft: spacing(2),
      height: 'auto',
      [breakpoints.up('sm')]: {
        height: 135,
        width: 270,
      },
    },
    content: {
      gridArea: 'content',
      paddingLeft: spacing(1),
      paddingRight: spacing(2),
      '& > div': {
        display: 'block',
        marginBottom: spacing(1),
      },
    },
    footer: {
      gridArea: 'footer',
    },
  })
);

export default function PathCardHorizontalSkeleton({ className = '' }) {
  const classes = useStyles();

  return (
    <div className={cx(classes.root, className)} data-testid="pathCardHorizontalSkeleton">
      <Skeleton variant="image" classes={{ root: classes.image }} />
      <div className={classes.content}>
        <Skeleton variant="rectangular" width={100} height={16} />
        <Skeleton width={240} />
        <Skeleton width={500} />
        <Skeleton width={125} />
      </div>
      <Skeleton variant="circular" height={40} width={40} classes={{ root: classes.footer }} />
    </div>
  );
}
